import { render, staticRenderFns } from "./signRecord.vue?vue&type=template&id=147772d4&scoped=true&"
import script from "./signRecord.vue?vue&type=script&lang=js&"
export * from "./signRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147772d4",
  null
  
)

export default component.exports